export default "__VITE_ASSET__2784b987__"